import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { BaasicConfirmModalTemplate } from 'themes/components';

function BaasicConfirmModal(props) {
	return <BaasicConfirmModalTemplate {...props} />;
}

BaasicConfirmModal.propTypes = {
	modalParams: PropTypes.object,
};

export default observer(BaasicConfirmModal);
